import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { actionNotificationsApiRef, ActionNotificationsClient } from './api';
import { actionRouteRef, rootRouteRef, testNotificationRouteRef } from './routes';

export const actionNotificationsPlugin = createPlugin({
  id: 'action-notifications',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: actionNotificationsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ActionNotificationsClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const ActionPage = actionNotificationsPlugin.provide(
  createRoutableExtension({
    name: 'ActionPage',
    component: () =>
      import('./components/ActionPage/ActionPage').then(m => m.ActionPage),
    mountPoint: actionRouteRef,
  }),
);

export const TestNotificationPage = actionNotificationsPlugin.provide(
  createRoutableExtension({
    name: 'TestNotificationPage',
    component: () =>
      import('./components/TestNotificationPage/TestNotificationPage').then(
        m => m.TestNotificationPage,
      ),
    mountPoint: testNotificationRouteRef,
  }),
);
